import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectAllCarImagesFolders, selectDealerMyCarPark, selectDealerProfile, selectProviderCarsByBusinessLine } from 'src/app/common/store/state/app.state';
import { DomSanitizer } from '@angular/platform-browser';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { FilesActions } from 'src/app/common/store/actions/files.actions';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { CarEditDialogComponent } from 'src/app/public/car/elements/car-edit/car-edit.component';
import { Car } from 'src/app/public/car/models/car.model';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { TransactionStage, TransactionRole } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { FileData } from 'src/app/public/common/models/file-data.model';


@Component({
    selector: 'app-provider-buy-offer',
    templateUrl: './provider-buy-offer.component.html',
    styleUrl: './provider-buy-offer.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProviderBuyOfferComponent  implements OnInit {
  
  sessionInfo = "Click to update data";
  
  progressInfos: any[] = [];
  message: string[] = [];

  myCars$: Observable<Car[]>;
  carImagesFolders$: Observable<Map<string, Array<FileData>>>;

  currentSeller$: Observable<Dealer>;
  currentSeller: Dealer = new Dealer();

  businessLine = CarBusinessLine.BUY
  transactionStages: TransactionStage[] = [];
  objectSource: ObjectSource = ObjectSource.BUY

  constructor(
    private store: Store, 
    private router: Router, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog) {
      
      //this.myCars$ = store.select(selectDealerMyCarPark);
      this.myCars$ = store.select(selectProviderCarsByBusinessLine(this.businessLine))
      this.carImagesFolders$ = store.select(selectAllCarImagesFolders);
      this.currentSeller$ = store.select(selectDealerProfile);
      
      this.currentSeller$.subscribe(
        (seller: Dealer) => {
          this.currentSeller = seller;
        }  
      ); 
    }
  
  ngOnInit(): void {

      //this.store.dispatch(DealerActions.fetchProviderParkSubmit());
      this.store.dispatch(DealerActions.providerOffersFetchMySubmit( { transactionRole: TransactionRole.PROVIDER, businessLine: this.businessLine, transactionStages: this.transactionStages } ));  
      
    }
    
  uploadImage(carId: string, event: any, ): void {
    this.message = [];
    this.progressInfos = [];
    let files: File[] = event.target.files;
    console.log('file name = '+files[0].name);

    if(files != undefined && files.length > 0){
      this.store.dispatch(FilesActions.uploadCarImageSubmit({ carId: carId, file: files[0] }));
    }
  }

  openCarEditDialog(): void {

    let car: Car = new Car();
    car.country = this.currentSeller.countryResident
    car.city = this.currentSeller.cityResident;
    

    const dialogRef = this.dialog.open(CarEditDialogComponent, {
      data: car
    });

    dialogRef.afterClosed().subscribe((result: any) => {

      //console.log(" result  = "+JSON.stringify(result));
      
      if(result != undefined ){
        //console.log(result)
        
        if(result.id === ''){
          this.store.dispatch(DealerActions.createNewCarSubmit({ car: result }));
        }
        else{
          this.store.dispatch(DealerActions.updateCarSubmit({ carUpdates: result }));
        }
      }    
    });
  } 
}
